"use strict";

/**
* Класс для реквизита типа «Дата».
* 
* @class WebAccess.components.wrappers.form.requisites.Date
* @extends WebAccess.components.wrappers.form.requisites.Text
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {obbject} data Данные для инициализации реквизита
* @since 5.0.0.7100
*/
(function (global) {
  /**
  * @inner
  */
  var onControlInitComplete = function (jControl, callback) {
    if (jControl.hasClass('inited')) {
      callback();
    } else {
      jControl.bind('Init', function () {
        callback();
      });
    }
  };

  var Date = global.WA.CMP.wrappers.form.requisites.Text.extend({
    className: "Date",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @private 
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindControlEvents
    * @since 5.0.0.7100
    */
    _bindControlEvents: function (jControl) {
      var me = this;
      var controlInit = $.Deferred();
      me._allControlsInit.push(controlInit);

      me._super(jControl);

      onControlInitComplete(jControl, function () {
        controlInit.resolve();
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.Date#_showSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.Date
    */
    _showSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var jContainer = jControl.parent();
        jContainer.find('.Req_Icon').hide();
        jContainer.append('<div class="circle-spinner refselect-input__spinner"></div>');
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.Date#_hideSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.Date
    */
    _hideSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var jContainer = jControl.parent();
        jContainer.find('.Req_Icon').show();
        jContainer.find('.circle-spinner').remove();
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**   
    * Установить значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Date#setValue
    * @param value {string} Устанавливаемое значение реквизита
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызов триггера события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Date} Текущий объект реквизита – Date.
    * @since 5.0.0.7100
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      if (value) {
        if (typeof value !== "object") {
          if (('' + value).indexOf('T') !== -1) {
            value = new window.Date(value);
          } else {
            value = parseDateTime(value);
          }
        }
        value = (this.isShowTime()) ? formatDateTime(value) : formatDate(value);
      } else {
        value = '';
      }
      return this._super(value, opt_displayValue, opt_needTriggerResult);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**     
    * Получить значение реквизита в виде JS-объекта типа «Дата».
    *
    * @method WebAccess.components.wrappers.form.requisites.Date#getDisplayValue
    * @return {WebAccess.components.wrappers.form.requisites.Date} Объект типа Date.
    * @since 5.0.0.7100
    */
    getDate: function () {
      var value = this.getValue();
      if (value) return parseDate(this.getValue());
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Отключение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Date#_disableControl
    * @return {WebAccess.components.wrappers.form.requisites.Date}
    * @private 
    * @since 5.0.0.7100
    */
    _disableControl: function (jControl) {
      this._super(jControl);
      var icon = jControl.siblings('.Req_Icon');
      if (icon.length) {
        icon.attr('readonly', 'readonly').addClass("Req_Icon_Disabled");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Date#_enableControl
    * @private 
    * @return {WebAccess.components.wrappers.form.requisites.Date}
    * @since 5.0.0.7100
    */
    _enableControl: function (jControl) {
      this._super(jControl);
      var icon = jControl.siblings('.Req_Icon');
      if (icon.length) {
        icon.removeAttr('readonly').removeClass("Req_Icon_Disabled");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Показывается ли время в реквизите.
     *
     * @method WebAccess.components.wrappers.form.requisites.Date#isShowTime
     * @return {boolean} True – реквизит показывает время, иначе False.
     * @since 5.2.0.2006
     */
    isShowTime: function () {
      var me = this;
      if (me.controls.length > 0) {
        var jControl = me.controls[0];
        return '' + jControl.siblings('.datepickerinfo').attr('showtime') === 'true';
      } else {
        return (me._data && me._data.dateFormat === 'DateTime');
      }
      return false;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.WA.CMP.wrappers.form.requisites.Date = Date;
})(window);


